// extracted by mini-css-extract-plugin
export default {"root":"PublicFile__root--7mh4x","content":"PublicFile__content--2YVML"};